import React from 'react';

import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import usePageMeta from 'seo/usePageMeta';
import kediOturan from 'assets/img/home/kedi-oturan.png';

// Split layout for the sign-in and password pages: form card plus a
// cat-themed side panel (shown first on desktop, after the form on mobile).
const AuthShell = ({ path, hideSignin, asideTitle, aside, children }) => {
  usePageMeta(path);
  return (
    <div className="op-home op-auth">
      <a className="op-skip" href="#icerik">
        İçeriğe geç
      </a>
      <SiteNav hideSignin={hideSignin} />
      <main id="icerik" className="op-wrap op-auth__grid">
        <section className="op-auth__card">{children}</section>
        <aside className="op-auth__aside">
          <img
            className="op-auth__cat"
            src={kediOturan}
            alt=""
            aria-hidden="true"
          />
          <h2>{asideTitle}</h2>
          {aside}
        </aside>
      </main>
      <SiteFooter />
    </div>
  );
};

export default AuthShell;
